var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "status-label",
          attrs: { id: _vm.triggerName },
          on: {
            mouseover: function ($event) {
              _vm.toggle = true
            },
            mouseleave: function ($event) {
              _vm.toggle = false
            },
            focus: function ($event) {
              _vm.toggle = true
            },
            blur: function ($event) {
              _vm.toggle = false
            },
          },
        },
        [
          _c(
            "mds-inline-message",
            {
              attrs: {
                size: "small",
                tinted: _vm.tinted,
                variation: _vm.status.variation,
              },
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.translate(_vm.status.text)) + "\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.status.variation === "error"
        ? _c(
            "mds-tooltip",
            {
              staticClass: "status-label__tooltip",
              attrs: {
                size: "small",
                "triggered-by": _vm.triggerName,
                position: ["bottom-right"],
              },
              model: {
                value: _vm.toggle,
                callback: function ($$v) {
                  _vm.toggle = $$v
                },
                expression: "toggle",
              },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.translate("schedule.failed.message")) +
                  "\n  "
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }